import { jsxs as t, jsx as l } from "react/jsx-runtime";
import { c as r } from "../../../index-CvSFHqCB.js";
import * as d from "react";
import { c as o } from "../../../utils-BOFVZgHd.js";
import { Checkbox as v } from "../../ui/checkbox.js";
import { Label as b } from "../../ui/label.js";
const g = r("flex items-center gap-2", {
  variants: {
    size: {
      default: "",
      sm: "max-w-sm",
      lg: "max-w-lg",
      full: "w-full"
    }
  },
  defaultVariants: {
    size: "default"
  }
}), h = r(
  "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
  {
    variants: {
      error: {
        true: "text-[var(--destructive)]",
        false: "text-[var(--foreground)]"
      }
    },
    defaultVariants: {
      error: !1
    }
  }
), w = r("text-sm text-[var(--destructive)]", {
  variants: {
    size: {
      default: "",
      sm: "text-xs",
      lg: "text-base",
      full: ""
    }
  },
  defaultVariants: {
    size: "default"
  }
}), V = d.forwardRef(
  ({ className: n, size: s, label: i, error: e, required: c, field: m, fieldControl: f, id: u }, x) => {
    const p = d.useId(), a = u || m?.fieldId || p;
    return /* @__PURE__ */ t("div", { className: "w-full flex flex-col gap-1.5", children: [
      /* @__PURE__ */ t("div", { className: o(g({ size: s, className: n })), children: [
        /* @__PURE__ */ l(
          v,
          {
            ...f?.field || {},
            ref: x,
            id: a,
            "aria-describedby": e ? `${a}-error` : void 0,
            "aria-invalid": !!e
          }
        ),
        i && /* @__PURE__ */ t(
          b,
          {
            htmlFor: a,
            className: o("text-sm font-medium leading-none", h({ error: !!e })),
            children: [
              i,
              c && " *"
            ]
          }
        )
      ] }),
      e && /* @__PURE__ */ l("p", { className: w({ size: s }), id: `${a}-error`, children: e })
    ] });
  }
);
V.displayName = "CheckboxField";
export {
  V as CheckboxField,
  g as checkboxFieldVariants
};
//# sourceMappingURL=index.js.map
